import { useTranslation } from 'react-i18next'

import { InfoIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import * as Styles from './styles'

const DiscardedContent = ({ isHs, showHts }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const discardedKey =
    isHs && showHts
      ? 'La recomendación de HS y HTS no se guardará.'
      : isHs
        ? 'La recomendación de HS no se guardará.'
        : 'La recomendación de HTS no se guardará.'

  return (
    <Styles.RightColumn>
      <Styles.InfoText type="bodyMRegular" color={theme.colors.text.default}>
        <InfoIcon size={24} />
        {t(discardedKey)}
      </Styles.InfoText>
    </Styles.RightColumn>
  )
}

export default DiscardedContent
